export default "/_next/static/chunks/fonts/din-regular-webfont-9077ac337786530ce63e697bae381f8b.woff";